export default "__VITE_ASSET__DeEdM$Ry__"